module.exports = __webpack_public_path__ + "static/media/Chandler-Harnish-professional.e74009dc.jpg";